export default __webpack_public_path__ + "static/media/newSet2-0-min.73c12f39.png";